import React from "react";
import NameListManager from "./NameListManager";

export default function SettingsExpenseTypes() {
  return (
    <NameListManager
      title="Expense types"
      endpoint="/admin/expense-types"
      listEndpoint="/expense-types"
      testidPrefix="expense-type"
      placeholder="e.g. Tamatar"
    />
  );
}
